import { getWalletSettings } from '../commands/walletCommands';
import { setWalletSettings } from '../state/actions/customizationActions';
import { store } from '../state/store';

export const tryToGetWalletSettings = async () => {
  try {
    const {
      userData: { user },
      customization: { internationalSettings },
    } = store.getState();
    const { countrySettingsByLocation } = internationalSettings;

    let currencyIsoCode;
    if (countrySettingsByLocation && countrySettingsByLocation.currencyISO) {
      currencyIsoCode = countrySettingsByLocation.currencyISO;
    }
    if (user && user.currency) {
      currencyIsoCode = user.currency.isoAlphabeticCode;
    }

    await loadWalletSettings(currencyIsoCode);
  } catch (e) {
    // do nothing
  }
};

export const loadWalletSettings = async (currencyIsoCode: string | undefined) => {
  try {
    if (currencyIsoCode) {
      const walletSettings = await getWalletSettings(currencyIsoCode);
      setWalletSettings(walletSettings);
    }
  } catch (e) {
    // do nothing
  }
};
